module.exports = __webpack_public_path__ + "static/media/about-2-2023.f25152cc.jpg";